<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Cotizaciones',
        buttons: [{ text: 'Nueva Cotización', routeLink: '/new_cotizacion' }],
        headers: [
          '#',
          'Material',
          'Cliente',
          'Colaborador',
          'Fecha',
          'Estatus',
          'Opciones',
        ],
        visibleColumnsMobile: [0, 3, 4, 5, 6],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeDelete"
      @confirm="deleteCotizacion"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    DeleteComp,
    SpinnerComp,
  },
  data() {
    return {
      isDeleteOpen: false,
      loading: false,
      rows: [],
      options: [
        {
          icon: "material-symbols-outlined picture_as_pdf",
          action: "pdf",
          color: "bg-red-500",
        },
        {
          icon: "KOC",
          action: "orden_compra",
          color: "bg-green-500",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  methods: {
    closeDelete() {
      this.isDeleteOpen = false;
    },
    handleOptionAction(action, row) {
      const actions = {
        pdf: () => {
          this.generatePdf(row.id);
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.id_cliente}?`;
          this.id = row.id;
          this.isDeleteOpen = true;
        },
        orden_compra: () => {
          this.$router.push({ name: "orden-compra", params: { id: row.id } });
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    getData() {
      this.loading = true;
      this.$axios
        .get("/getCot")
        .then((response) => {
          this.rows = response.data.cotizaciones;
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteCotizacion() {
      this.$axios
        .delete(`/deleteCot/${this.id}`)
        .then((response) => {
          this.closeDelete();
          alert(response.data.message);
          this.getData();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.message);
          }
        });
    },
    generatePdf(id) {
      this.$axios
        .get(`/generate-pdf/${id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const newTab = window.open(url, "_blank");

          if (
            !newTab ||
            newTab.closed ||
            typeof newTab.closed === "undefined"
          ) {
            // fallback para navegadores con bloqueo de pop-ups
            const link = document.createElement("a");
            link.href = url;
            link.download = `archivo-${id}.pdf`;
            link.click();

            alert(
              "El PDF no pudo abrirse en una nueva ventana. Se descargará automáticamente."
            );
          }
        })
        .catch((error) => {
          console.error("Error al generar PDF:", error);
          alert(error?.response?.data?.message || "Error al generar el PDF.");
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
